import { Trans, useLingui } from "@lingui/react/macro";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { Heading } from "@medoma/components/Heading/Heading";
import { patientStatusSchema } from "@medoma/models/patients";
import { useParentRoutesPatient } from "@/api/Patients";
import { AdmitPatientForm } from "@/forms/RegisterPatientForm/AdmitPatientForm";
import styles from "./AdmitPatient.module.scss";

export const AdmitPatient = () => {
  const { t } = useLingui();
  const patient = useParentRoutesPatient();

  return (
    <div className={styles.admitPatient}>
      <Heading level="h1">
        <Trans>Fullfölj inskrivning</Trans>
      </Heading>
      {patient.status === patientStatusSchema.enum.prospect ? (
        <AdmitPatientForm patient={patient} />
      ) : (
        <ErrorMessage
          message={t`Det är bara patienter under bedömning som kan skrivas in.`}
        />
      )}
    </div>
  );
};
